module.exports = __webpack_public_path__ + "img/Panda-Fight-Esport-Logo-Template.jpg";